import firebase from 'firebase'
import firestore from 'firebase/firestore'

//Initialize Firebase
var firebaseConfig = {
    apiKey: "AIzaSyAvVoBjeNqU9X5OkXQweidMgDMpiu1UaJw",
    authDomain: "pwa-hmy-group.firebaseapp.com",
    databaseURL: "https://pwa-hmy-group.firebaseio.com",
    projectId: "pwa-hmy-group",
    storageBucket: "pwa-hmy-group.appspot.com",
    messagingSenderId: "745080149960",
    appId: "1:745080149960:web:89d2ba07d685fc7fb192fd"
  };

const firebaseApp=  firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore();
